import { X, Minus, Plus, Trash2, MessageCircle, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { open, setOpen, items, setQty, removeItem, totals, waLink, clear } =
    useCart();

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 z-[70] bg-black/50 transition-opacity ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
      />
      {/* Drawer */}
      <aside
        data-testid="cart-drawer"
        aria-hidden={!open}
        className={`fixed top-0 right-0 z-[80] h-full w-full sm:w-[420px] bg-[#FAFAFA] border-l-2 border-black flex flex-col transform transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <header className="flex items-center justify-between px-5 py-4 border-b-2 border-black bg-[#FFB800]">
          <div className="flex items-center gap-3">
            <ShoppingBag size={20} strokeWidth={2.5} />
            <div className="font-display text-2xl uppercase">Your Order</div>
          </div>
          <button
            onClick={() => setOpen(false)}
            data-testid="cart-close-btn"
            className="brutal-border bg-white p-1.5"
            aria-label="close"
          >
            <X size={18} strokeWidth={2.5} />
          </button>
        </header>

        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {items.length === 0 ? (
            <div className="text-center py-16">
              <ShoppingBag size={42} className="mx-auto mb-3 text-neutral-400" />
              <div className="font-display text-2xl uppercase">Cart is empty</div>
              <div className="text-sm text-neutral-600 mt-1">
                Add something tasty from the menu!
              </div>
            </div>
          ) : (
            items.map((it) => (
              <div
                key={it.id}
                data-testid={`cart-item-${it.id.toLowerCase().replace(/\s+/g, "-")}`}
                className="brutal-border bg-white p-3 flex items-start gap-3"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-display text-lg leading-tight uppercase">
                    {it.name}
                  </div>
                  {it.price != null && (
                    <div className="text-xs text-neutral-700 mt-0.5">
                      ₹{it.price} each
                    </div>
                  )}
                  <div className="mt-2 inline-flex items-stretch brutal-border bg-white">
                    <button
                      onClick={() => setQty(it.id, it.qty - 1)}
                      className="px-2 py-1 hover:bg-[#FFB800]"
                      aria-label="decrease"
                    >
                      <Minus size={12} strokeWidth={3} />
                    </button>
                    <div className="px-3 py-1 font-display text-base leading-none border-x-2 border-black min-w-[36px] text-center">
                      {it.qty}
                    </div>
                    <button
                      onClick={() => setQty(it.id, it.qty + 1)}
                      className="px-2 py-1 hover:bg-[#FFB800]"
                      aria-label="increase"
                    >
                      <Plus size={12} strokeWidth={3} />
                    </button>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  {it.price != null && (
                    <div className="font-display text-xl text-[#D92525]">
                      ₹{it.price * it.qty}
                    </div>
                  )}
                  <button
                    onClick={() => removeItem(it.id)}
                    className="mt-2 brutal-border bg-black text-white p-1.5"
                    aria-label="remove"
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <footer className="border-t-2 border-black bg-white p-5 space-y-3">
            <div className="flex items-baseline justify-between">
              <span className="text-xs uppercase tracking-widest font-bold text-neutral-700">
                Total ({totals.count} item{totals.count > 1 ? "s" : ""})
              </span>
              <span className="font-display text-3xl text-[#D92525]">
                {totals.total > 0 ? `₹${totals.total}` : "—"}
              </span>
            </div>
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              data-testid="cart-checkout-btn"
              className="w-full inline-flex items-center justify-center gap-2 brutal-border brutal-shadow bg-[#25D366] text-black font-bold px-5 py-4 text-sm uppercase tracking-widest"
            >
              <MessageCircle size={18} strokeWidth={2.5} />
              Order on WhatsApp
            </a>
            <button
              onClick={clear}
              data-testid="cart-clear-btn"
              className="w-full text-xs uppercase tracking-widest font-bold text-neutral-600 hover:text-[#D92525] py-1"
            >
              Clear cart
            </button>
            <p className="text-[10px] text-neutral-500 text-center uppercase tracking-widest">
              Message goes via WhatsApp · Fill in your name & address
            </p>
          </footer>
        )}
      </aside>
    </>
  );
}
